import { render, staticRenderFns } from "./labAndExamInfo.vue?vue&type=template&id=48aeef04"
import script from "./labAndExamInfo.vue?vue&type=script&lang=js"
export * from "./labAndExamInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports